module.exports = __webpack_public_path__ + "fa-brands-400.921f1150167369cf4c40.woff2";


//////////////////
// WEBPACK FOOTER
// /app/frontend/src/assets/fontawesome/webfonts/fa-brands-400.woff2
// module id = ../../../../../src/assets/fontawesome/webfonts/fa-brands-400.woff2
// module chunks = styles